import { RouteType } from "types/RouteType";
import devopsOverviewRoute from "./DevOpsOverview/devopsOverview.Route";
import devopsProjectRoute from "./DevOpsProject/devopsProject.Route";
import devopsConnectionsRoute from "./DevOpsConnections/devopsConnections.Route";
import devopsSubscriptionsRoute from "./DevOpsSubscriptions/devopsSubscriptions.Route";
import buildBoardRoute from "./BuildBoard/buildBoard.Route";
import releasesRoute from "./Releases/releases.Route";
import reposRoute from "./Repos/repos.Route";
import workItemsRoute from "./WorkItems/workItems.Route";

const devopsRoutesList: RouteType[] = [
  // FIRST: /devops is the DevOps landing — projects grouped by client.
  ...devopsOverviewRoute,
  ...devopsProjectRoute,
  ...devopsConnectionsRoute,
  ...devopsSubscriptionsRoute,
  // The Pipelines page: every build across every project (BuildBoard/).
  ...buildBoardRoute,
  ...releasesRoute,
  ...reposRoute,
  ...workItemsRoute,
];

export default devopsRoutesList;
